module.exports = __webpack_public_path__ + "static/img/bg.58421dcb.jpg";